module.exports = __webpack_public_path__ + "img/Liquid-Cheese.c6faf749.svg";